export default {
  YOLA_PARTNER_ID: 'YOLA',
  COOKIE_PARTNER_ID_ITEM: 'yopid',
};
